import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let commandCenterMountPromise = null;

export function initCommandCenterViewFragment({ onMounted } = {}) {
  registerViewMount('command-center', () => mountCommandCenterView(onMounted));
}

async function mountCommandCenterView(onMounted) {
  if (document.getElementById('view-command-center')) return;
  if (commandCenterMountPromise) return commandCenterMountPromise;

  commandCenterMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');
    await appendTrustedAdminViewFragment(host, '/admin-views/command-center.html', 'Unable to load command center view');
    onMounted?.();
  })();

  try {
    await commandCenterMountPromise;
  } catch (error) {
    commandCenterMountPromise = null;
    throw error;
  }
}
